import React, { useCallback } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Close } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { LinkButton, Stack, Tooltip } from '@lyearn/ui';
import StaffRoleItem from '@/modules/corporate/modules/staff-roles/components/StaffRoleItem';
import { StaffRoleWithRoleProfileFragment } from '@/modules/corporate/modules/staff-roles/graphql/fragments/generated/StaffRoleWithRoleProfile';

import { listItemStyle } from './styles';

interface ListItemProps {
  staffRole: StaffRoleWithRoleProfileFragment;
  onRemove: (roleId: string) => void;
  disabled?: boolean;
}

function ListItem(props: ListItemProps) {
  const { t } = useTranslation();
  const { staffRole, onRemove, disabled } = props;

  const _onRemove = useCallback(() => {
    onRemove(staffRole.id);
  }, [onRemove, staffRole.id]);

  return (
    <Stack className={cn(listItemStyle, 'truncate border-b border-divider')}>
      <Stack
        className={cn('w-full truncate rounded-8 px-16 py-16', {
          'group hover:bg-bg-hover': !disabled,
        })}
        justifyContent="between">
        <StaffRoleItem staffRole={staffRole} />
        <Tooltip placement="right" title={t('AssignmentRestriction:RemoveStaffRole') ?? ''}>
          <LinkButton
            className="flex-shrink-0 py-2 px-4 px-0 opacity-0 transition duration-150 ease-linear group-hover:opacity-100"
            color={'internal'}
            disabled={disabled}
            onClick={_onRemove}>
            <Close />
          </LinkButton>
        </Tooltip>
      </Stack>
    </Stack>
  );
}

export default ListItem;
